import React, { useEffect, useState } from "react";
import { fetchGlobalConfig } from "../utils/contentfulRequests";
import { Box, Typography } from "@mui/material";

const NotFound = () => {
  const [globalConfig, setGlobalConfig] = useState(null);

  useEffect(() => {
    fetchGlobalConfig().then(setGlobalConfig);
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        px: 2,
      }}
    >
      {globalConfig?.page404 && (
  <img
    src={globalConfig.page404}
    alt="Página no encontrada"
    style={{
      maxWidth: "100vw",
      maxHeight: "70vh",
      width: "100%",
      height: "auto",
      display: "block",
      margin: "0 auto 24px auto",
      objectFit: "contain",
    }}
  />
)}
      <Typography variant="h3" color="text.secondary" gutterBottom>
        404 - Página no encontrada
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Lo sentimos, la página que buscas no existe.
      </Typography>
    </Box>
  );
};

export default NotFound;